
import { defineComponent, computed } from 'vue'
import { useGlobal, useLog } from '@/hooks'
import { ElMessage } from 'element-plus'

export default defineComponent({
  setup() {
    // Hooks
    // eslint-disable-next-line
    const l = useLog()
    const { globalData, updateNickname, updateNicknameLockStatus } = useGlobal()

    // Computed
    const btnLockTxt = computed(() =>
      globalData.nicknameLockStatus ? 'info' : 'primary'
    )
    const btnLockTipTxt = computed(() =>
      globalData.nicknameLockStatus ? '解锁' : '锁定'
    )

    // Method
    // 改变游客昵称
    const changeNickname = (newNickname: string) => updateNickname(newNickname)
    // 改变游客昵称锁定状态
    const changeNicknameLockStatus = (newStatus: boolean) => {
      updateNickname((globalData.nickname as string).trim())
      if (!globalData.nicknameLockStatus && globalData.nickname == '') {
        ElMessage.error('亲, 你必须提供一个昵称哦.')
        return
      }
      updateNicknameLockStatus(newStatus)
      // ElNotification.success({
      //   title: '欢迎',
      //   message:`欢迎你${globalData.nickname}`
      // })
    }

    return {
      globalData,
      btnLockTxt,
      btnLockTipTxt,
      changeNickname,
      changeNicknameLockStatus,
    }
  },
})
